/**
 * 全局getters函数
 */

let getters = {
  getFarmId(state) {
    return state.farmId;
  },
  getDeviceClass(state) {
    return state.deviceClass;
  },
  getRoomList(state) {
    return state.roomList;
  }
};

export default getters;